import { useLayoutEffect, useRef, useState } from 'react'

function useSearchGridColumns<T>(items: Array<T>): {
  containerRef: React.RefObject<HTMLDivElement | null >
  itemRef: React.RefObject<HTMLElement | null>
  numColumns: number | undefined
} {
  const containerRef = useRef<HTMLDivElement>(null)
  const itemRef = useRef<HTMLElement>(null)
  const [numColumns, setNumColumns] = useState<number | undefined>(undefined)

  useLayoutEffect(() => {
    const containerWidth = containerRef.current?.getBoundingClientRect().width ?? 0
    const itemWidth = itemRef.current?.getBoundingClientRect().width ?? 0

    if (containerWidth === 0 || itemWidth === 0) {
      setNumColumns(undefined)
      return
    }

    setNumColumns(Math.floor(containerWidth / itemWidth))
  }, [items])

  return { containerRef, itemRef, numColumns }
}

export default useSearchGridColumns
